<script>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";

export default {
  page: {
    title: "Recently Paid",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      title: "Recently Paid",
      items: [
        {
          text: "Home",
        },
         {
          text: "Payment",
        },
        {
          text: "Recently Paid",
          active: true,
        },
      ],
    };
  },
  components: {
    Layout,
    PageHeader,
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
  </Layout>
</template>